import { useEffect, useState } from 'react';

import { endpoints } from '@/API/endpoints';
import { useApi } from '@/hooks/useApi/useApi';
import { ApiDataType } from '@/types';

import MembersList from '../members-list/MembersList';

const MembersProject = ({ isMembersOpen }: { isMembersOpen: boolean }) => {
	const [members, setMembers] = useState<ApiDataType | null>(null);

	const { apiGet } = useApi();

	const getMembers = async (id: string) => {
		const res = await apiGet(`${endpoints.project}${id}/project_available_employees/`);
		if (res.errorMessage.length > 0) {
			setMembers(res);
		} else {
			setMembers({
				data: res.data.project_employees,
				errorMessage: res.errorMessage,
			});
		}
	};

	useEffect(() => {
		const id = globalThis.location.pathname.split('/projects/')[1];
		getMembers(id);
	}, []);
	return members && <MembersList isOpen={isMembersOpen} members={members} />;
};

export default MembersProject;
